import { INQUIRY_TYPE_OPTIONS } from "@/constants/inquiry";
import { Col, DatePicker, Form, Input, Row, Select } from "antd";
import styles from "@/asserts/styles/formSection.module.less";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { EditInquiryFormValues } from "../type";
import { useTranslation } from "react-i18next";

export function BasicInfoFormFields() {
  const { t } = useTranslation("inquiryManagement");
  const form = Form.useFormInstance<EditInquiryFormValues>();

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("询价基本信息")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<EditInquiryFormValues>
              name="biddingType"
              label={t("询价类型")}
              rules={[
                {
                  required: true,
                  message: t("请选择询价类型"),
                },
              ]}
            >
              <Select
                options={INQUIRY_TYPE_OPTIONS}
                onChange={() => form.setFieldValue("itemList", [{}])}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<EditInquiryFormValues>
              name="biddingName"
              label={t("询价单标题")}
              rules={[
                {
                  required: true,
                  message: t("请输入询价单标题"),
                },
              ]}
            >
              <Input placeholder={t("请输入询价单标题")} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<EditInquiryFormValues>
              name="deadline"
              label={t("截止时间")}
              rules={[
                {
                  required: true,
                  message: t("请选择截止时间"),
                },
              ]}
            >
              <DatePicker
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD HH:mm"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </div>
  );
}
